/**
 * Constants for landlord portal
 * Enumerated values for property and unit fields
 */

/**
 * Property status enumeration
 */
export const PropertyStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  DELETED: 'deleted',
} as const;

export type PropertyStatusValue = typeof PropertyStatus[keyof typeof PropertyStatus];

/**
 * Property type enumeration
 */
export const PropertyType = {
  SINGLE_FAMILY: 'single_family',
  MULTI_FAMILY: 'multi_family',
  APARTMENT: 'apartment',
  CONDO: 'condo',
  TOWNHOUSE: 'townhouse',
  COMMERCIAL: 'commercial',
  MIXED_USE: 'mixed_use',
  OTHER: 'other',
} as const;

export type PropertyTypeValue = typeof PropertyType[keyof typeof PropertyType];

/**
 * Unit status enumeration
 */
export const UnitStatus = {
  AVAILABLE: 'available',
  OCCUPIED: 'occupied',
  MAINTENANCE: 'maintenance',
  INACTIVE: 'inactive',
  DELETED: 'deleted',
} as const;

export type UnitStatusValue = typeof UnitStatus[keyof typeof UnitStatus];

/**
 * Human-readable labels for property types
 */
export const PropertyTypeLabel: Record<PropertyTypeValue, string> = {
  [PropertyType.SINGLE_FAMILY]: 'Single Family',
  [PropertyType.MULTI_FAMILY]: 'Multi Family',
  [PropertyType.APARTMENT]: 'Apartment',
  [PropertyType.CONDO]: 'Condominium',
  [PropertyType.TOWNHOUSE]: 'Townhouse',
  [PropertyType.COMMERCIAL]: 'Commercial',
  [PropertyType.MIXED_USE]: 'Mixed Use',
  [PropertyType.OTHER]: 'Other',
};
